export var AssignTicketTypes;
(function (AssignTicketTypes) {
    AssignTicketTypes[AssignTicketTypes["USER"] = 1] = "USER";
    AssignTicketTypes[AssignTicketTypes["GROUP"] = 2] = "GROUP";
})(AssignTicketTypes || (AssignTicketTypes = {}));
export var RuleTrigger;
(function (RuleTrigger) {
    RuleTrigger[RuleTrigger["TICKET_CREATED"] = 10] = "TICKET_CREATED";
    RuleTrigger[RuleTrigger["USER_REPLY"] = 20] = "USER_REPLY";
    RuleTrigger[RuleTrigger["AGENT_REPLY"] = 30] = "AGENT_REPLY";
})(RuleTrigger || (RuleTrigger = {}));
//# sourceMappingURL=rule.i.js.map